import React from "react";
import LoadingSpinner from "../../../components/LoadingSpinner";
import CoachesList from "../../common/coaches/CoachesList";
import SearchCoaches from "../../common/coaches/SearchCoaches";

export default function CoachesSearchList({
  searchQuery,
  onSearchChange,
  loading,
  error,
  visibleCoaches,
  listHeight,
  selectedCoach,
  getCoachId,
  onSelectCoach,
  loadMoreSentinelRef,
  isLoadingMore,
  hasMore,
}) {
  return (
    <>
      <SearchCoaches
        searchQuery={searchQuery}
        onSearchChange={onSearchChange}
        loadOnMount={false}
      />
      {loading && <LoadingSpinner />}
      {error && <p className="text-red-500">{error}</p>}

      <div
        className="mt-4 pr-4 -mr-4 overflow-y-auto"
        style={{ height: `${listHeight}px` }}
      >
        {!loading && visibleCoaches && visibleCoaches.length > 0 ? (
          <>
            {visibleCoaches.map((coach) => (
              <div
                key={getCoachId(coach)}
                className="cursor-pointer"
                onClick={() => onSelectCoach(coach)}
              >
                <CoachesList
                  coach={coach}
                  showArrow={true}
                  isSelected={getCoachId(selectedCoach) === getCoachId(coach)}
                />
              </div>
            ))}

            <div ref={loadMoreSentinelRef} style={{ height: "1px" }} />

            {isLoadingMore && (
              <div className="flex justify-center py-4">
                <div className="text-gray-500 text-sm">
                  Loading more coaches...
                </div>
              </div>
            )}

            {!hasMore && visibleCoaches.length > 0 && (
              <div className="flex justify-center py-4">
                <div className="text-gray-400 text-sm">
                  All coaches loaded ({visibleCoaches.length} total)
                </div>
              </div>
            )}
          </>
        ) : loading ? (
          <div className="h-full flex items-center justify-center ">
            <div className="w-full flex flex-col items-center text-gray-800">
              <img
                alt="Athlete Name"
                src="/nodata.gif"
                className="object-cover h-20 ml-18 pb-3"
              ></img>
              <p className="text-center text-[#8E8E93] text-1xl">
                Please wait while we load the data.
              </p>
            </div>
          </div>
        ) : (
          <div className="h-full flex items-center justify-center ">
            <div className="w-full flex flex-col items-center text-gray-800">
              <img
                alt="No coaches found"
                src="/nodata.gif"
                className="object-cover h-20 ml-18 pb-3"
              ></img>
              <p className="text-center text-[#8E8E93] text-1xl">
                No coaches match your search.
              </p>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
